import { 
    // [案件] 房東政策設定頁面(使用裡面政策列表)
    apiBizGetLanlordPolicy,
    // 批量政策列表
    apiBizGetBatchPolicyList,
    //批量替換政策
    apiBizUpdateBatchPolicy,
    // 批量新增政策
    apiBizCreateBatchPolicy,
    // 批量清空政策
    apiBizDeleteBatchPolicy
    } from "@/apis/api.js"; 

/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_checkbox_status: 'batchPolicy/set_checkbox_status',
    set_selected_policy: 'batchPolicy/set_selected_policy',
    set_selected_house: 'batchPolicy/set_selected_house',
    set_landlord_policy_list: 'batchPolicy/set_landlord_policy_list',
    set_batch_policy_list: 'batchPolicy/set_batch_policy_list',
    set_filter_query: 'batchPolicy/set_filter_query',
    set_success_list: 'batchPolicy/set_success_list',
}

// count state 必須是 Object
const state = {
    bizLandlordPolicyList: [],
    bizBatchPolicyList: [],
    checkboxStatus: {
        checkboxAll: false,
    },
    selectedPolicy: [],
    selectedHouse: [],
    filterQuery: {},
    filterQueryUpdate: 0,
    successList: []

}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LANDLORD_POLICY_LIST: (state) => {
        return state.bizLandlordPolicyList
    },
    GET_BIZ_BATCH_POLICY_LIST: (state) => {
        return state.bizBatchPolicyList
    },
    GET_BIZ_BATCH_POLICY_SUCCESS_LIST: (state) => {
        return state.successList
    },
    GET_BIZ_BATCH_POLICY_LIST_TOTAL: (state) => {
        return state.bizBatchPolicyList.length
    },
    GET_BIZ_BATCH_POLICY_CHECKBOX_STATUS: (state) => {
        return state.checkboxStatus
    },
    GET_BIZ_BATCH_POLICY_HAS_SELECTED_HOUSE: (state) => {
        return state.selectedHouse.length?true:false
    },
    GET_BIZ_BATCH_POLICY_SELECTED_HOUSE_CID: (state) => {
        // state.checkboxStatus.update
        return state.selectedHouse
    },
    GET_BIZ_BATCH_POLICY_SELECTED_POLICY_CID: (state) => {
        let policyList = state.selectedPolicy
        let policyCid = []
    
        for (let i = 0; i < policyList.length; i++) {
            const element = policyList[i];
            policyCid.push(element.policySettingCid)
        }
        return policyCid
    },
    GET_BIZ_BATCH_POLICY_FILTER_QUERY: (state) => {
        return state.filterQuery
    },
    GET_BIZ_BATCH_POLICY_FILTER_QUERY_UPDATE: (state) => {
        return state.filterQueryUpdate
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizLandlordPolicyList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetLanlordPolicy(data)
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let landlordPolicy = res.data.result.landlordHousePolicyDto.policySettingDtoList
                    commit(types.set_landlord_policy_list, landlordPolicy)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    getBizBatchPolicyList ( {commit}, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetBatchPolicyList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    let batchPolicy = res.data.result
                    commit(types.set_batch_policy_list, batchPolicy)
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    createBizBatchPolicy ( {commit, dispatch, getters} ) {
        return new Promise((resolve, reject) => {
            let data = {
                housesCid: getters.GET_BIZ_BATCH_POLICY_SELECTED_HOUSE_CID,
                policiesCid: getters.GET_BIZ_BATCH_POLICY_SELECTED_POLICY_CID,
            }
            apiBizCreateBatchPolicy(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchPolicyList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    updateBizBatchPolicy ( {commit, dispatch, getters} ) {
        return new Promise((resolve, reject) => {
            let data = {
                housesCid: getters.GET_BIZ_BATCH_POLICY_SELECTED_HOUSE_CID,
                policiesCid: getters.GET_BIZ_BATCH_POLICY_SELECTED_POLICY_CID,
            }
            apiBizUpdateBatchPolicy(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchPolicyList')
                    commit(types.set_success_list)
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    deleteBizBatchPolicy ( {dispatch, getters} ) {
        return new Promise((resolve, reject) => {
            let data = {
                housesCid: getters.GET_BIZ_BATCH_POLICY_SELECTED_HOUSE_CID,
            }
            apiBizDeleteBatchPolicy(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    dispatch('getBizBatchPolicyList')
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
        })
    },
    setCheckboxStatus ( {commit}, data ) {
        commit(types.set_checkbox_status, data)
    },
    setSeletedPolicy ( {commit}, data ) {
        commit(types.set_selected_policy, data)
    },
    setSeletedHouse ( {commit}, data ) {
        commit(types.set_selected_house, data)
    },
    setBizBatchPolicyFilterQuery ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
    setSuccessFlag ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_query, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_checkbox_status](state, data){
        state.checkboxStatus = data
    },
    [types.set_selected_policy](state, data){
        state.selectedPolicy = data
    },
    [types.set_selected_house](state, data){
        state.selectedHouse = data
    },
    [types.set_landlord_policy_list](state, data){
        state.bizLandlordPolicyList = data
    },
    [types.set_batch_policy_list](state, data){
        state.bizBatchPolicyList = data
    },
    [types.set_filter_query](state, data){
        state.filterQuery = data
        state.filterQueryUpdate += 1
    },
    [types.set_success_list](state){
        state.successList = state.selectedHouse
    },
    
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/mgtCategory/houseMgt/batchPolicy.js